import { useState } from 'react';
import { usePageMeta } from '../hooks/usePageMeta';

export default function ContatoPage() {
    usePageMeta({
        title: 'Contato — Fale com a Bysetup',
        description: 'Fale com a Bysetup pelo canal oficial: parcerias, publicidade, propostas e sugestões. Respondemos em até 48 horas úteis.',
        path: '/contato'
    });

    const [formData, setFormData] = useState({
        nome: '',
        email: '',
        assunto: '',
        mensagem: ''
    });

    const [enviando, setEnviando] = useState(false);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setEnviando(true);

        const to = 'bysetup.contato@gmail.com';
        const subject = '[Bysetup] ' + (formData.assunto || 'Outros');
        const body =
            `Nome: ${formData.nome}\n` +
            `Email: ${formData.email}\n` +
            `Assunto: ${formData.assunto}\n\n` +
            `Mensagem:\n${formData.mensagem}`;

        const mailtoUrl = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        window.location.href = mailtoUrl;

        setTimeout(() => setEnviando(false), 500);
    };

    return (
        <main>
            <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
                <div className="container">
                    <h1 className="display-5 fw-bold mb-3">Contato</h1>
                    <p className="lead text-muted mb-0">
                        Fale com a Bysetup por um unico canal oficial.
                    </p>
                </div>
            </section>

            <section className="py-5">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-lg-7">
                            <div className="card border-0 shadow-sm">
                                <div className="card-body p-4 p-md-5">
                                    <h2 className="h4 fw-bold mb-3">Envie sua mensagem</h2>
                                    <p className="text-muted mb-4">
                                        Ao clicar em Enviar, abriremos seu app de e-mail com os dados preenchidos.
                                    </p>

                                    <form onSubmit={handleSubmit}>
                                        <div className="mb-3">
                                            <label htmlFor="nome" className="form-label">Nome</label>
                                            <input
                                                id="nome"
                                                name="nome"
                                                type="text"
                                                className="form-control"
                                                placeholder="Seu nome"
                                                value={formData.nome}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="email" className="form-label">E-mail</label>
                                            <input
                                                id="email"
                                                name="email"
                                                type="email"
                                                className="form-control"
                                                placeholder="voce@email.com"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="assunto" className="form-label">Assunto</label>
                                            <select
                                                id="assunto"
                                                name="assunto"
                                                className="form-select"
                                                value={formData.assunto}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="" disabled>Selecione um assunto</option>
                                                <option value="Parcerias e publicidade">Parcerias e publicidade</option>
                                                <option value="Propostas e sugestões">Propostas e sugestões</option>
                                                <option value="Contato com clientes">Contato com clientes</option>
                                                <option value="Outros">Outros</option>
                                            </select>
                                        </div>

                                        <div className="mb-4">
                                            <label htmlFor="mensagem" className="form-label">Mensagem</label>
                                            <textarea
                                                id="mensagem"
                                                name="mensagem"
                                                className="form-control"
                                                rows="6"
                                                placeholder="Escreva sua mensagem"
                                                value={formData.mensagem}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        <button
                                            type="submit"
                                            className="btn btn-primary px-4"
                                            disabled={enviando}
                                        >
                                            {enviando ? 'Abrindo e-mail...' : 'Enviar'}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-5">
                            <div className="card border-0 bg-light h-100">
                                <div className="card-body p-4 p-md-5">
                                    <h3 className="h5 fw-bold mb-3">Canal oficial</h3>
                                    <p className="text-muted mb-1">E-mail unico:</p>
                                    <p className="mb-4">
                                        <a className="text-decoration-none" href="mailto:bysetup.contato@gmail.com">
                                            bysetup.contato@gmail.com
                                        </a>
                                    </p>

                                    <h4 className="h6 fw-bold mb-2">Prazo de resposta</h4>
                                    <p className="text-muted mb-0">Até 48 horas uteis.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}